export enum Modalidade {
  fomento = "Fomento",
  colaboracao = "Colaboração",
  contribuicao = "Contribuicao",
}
